<template>
  <app-layout>
    <div class="bax-banner-wrap">
      <order-header />
      <order-steps :active="1" />
    </div>

    <main>
      <div class="bax-section">
        <div class="container">
          <div class="bax-info-section">
            <div class="bax-info-content">
              <h3>Important information</h3>
              <p>Download the Compounding Plus App for: Drug stability Guide,
                Bag Volume Reference, Creatinine Clearance Calculator, BMI Calculator & BSA Calculator.
              </p>
            </div>
          </div>
          <div class="bax-action-items">
            <ul class="d-md-flex">
              <li>
                <router-link v-bind:to="{name: 'createOrder'}" class="bax-bg-green">
                  <i class="icon-create-order"></i>
                  <span>
                    <strong>Create</strong> a new order
                  </span>
                  <span class="bax-action-btn d-flex align-items-center justify-content-center">
                    Start <i class="icon-chevron-right"></i>
                  </span>
                </router-link>
              </li>
              <li>
                <a href="#" class="bax-bg-light-blue">
                  <i class="icon-reuse"></i>
                  <span>
                    <strong>Reuse</strong> a past order
                  </span>
                  <span class="bax-action-btn d-flex align-items-center justify-content-center">
                    Search <i class="icon-chevron-right"></i>
                  </span>
                </a>
              </li>
              <li>
                <a href="#" class="bax-bg-purple-1">
                  <i class="icon-upload"></i>
                  <span>
                    <strong>Upload</strong> a bulk order
                  </span>
                  <span class="bax-action-btn d-flex align-items-center justify-content-center">
                    Upload <i class="icon-chevron-right"></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div class="bax-cta-block">
            <router-link :to="{ name: 'home' }" class="bax-btn bax-btn-bordered bax-btn-bordered-blue">
              Back
            </router-link>
          </div>
        </div>
      </div>
    </main>
  </app-layout>
</template>

<script>
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderHeader from '@/components/order/OrderHeader.vue';
import { scrollPageToTop } from '@/core/helpers';
import OrderSteps from '../OrderSteps.vue';

export default {
  name: 'StartOrder',
  components: {
    AppLayout,
    OrderHeader,
    OrderSteps,
  },
  created() {
    scrollPageToTop();
  },
};
</script>
